import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FhNameBadgeComponent } from './components/fh-name-badge.component';
import { SkeletonModule } from 'primeng/skeleton';
import { FhCardModule } from '@fh-client-interaction-frontends/fh-card';
import { FhTextModule } from '@fh-client-interaction-frontends/fh-text';

@NgModule({
  imports: [CommonModule, SkeletonModule, FhCardModule, FhTextModule],
  declarations: [FhNameBadgeComponent],
  exports: [FhNameBadgeComponent]
})
export class FhNameBadgeModule {}
